import readyHandler from "../lib/readyHandler";

readyHandler.ready(function () {
  Array.from(document.getElementsByTagName("a"))
    .filter((a) => a.host != document.location.host)
    .forEach((a) => (a.target = a.target || "_blank"));
});
